<template>
  <div>
    <v-list class="date-range-tooltip" two-line flat v-if="!isMobile">
      <v-radio-group :value="radioGroup" @change="handleSelectTime">
        <v-list-tile v-for="(time, index) in timeOptions" :key="index">
          <v-radio :value="time.value" class="a-time-picker__option">
            <template v-slot:label>
              <div class="a-time-picker__label">
                <div class="a-time-picker__label-main">{{ time.text }}</div>
                <div class="a-time-picker__label-sub" v-if="templateOptions[time.value]">
                  {{ templateOptions[time.value].hint }}
                </div>
              </div>
            </template>
          </v-radio>
        </v-list-tile>
        <template v-if="customTime">
          <div class="box-select">
            <v-menu v-model="showFromDate" :full-width="true" :nudge-right="220" :nudge-top="50">
              <ATextField
                dark
                svgIcon
                readonly
                slot="activator"
                name="fromDate"
                appendIcon="DateTime"
                :label="$t('date_range_picker.from_time')"
                v-model="formatedFromDate"
              />
              <v-date-picker
                header-color="warning"
                v-model="params.fromDate"
                :max="maxDate"
                @input="updateFromDate"
              ></v-date-picker>
            </v-menu>
            <v-menu v-model="showToDate" :full-width="true" :nudge-right="220" :nudge-top="20">
              <ATextField
                dark
                svgIcon
                readonly
                name="toDate"
                slot="activator"
                appendIcon="DateTime"
                :label="$t('date_range_picker.to_time')"
                v-model="formatedToDate"
              />
              <v-date-picker
                header-color="warning"
                v-model="params.toDate"
                :max="maxDate"
                :min="minToDate"
                @input="updateToDate"
              ></v-date-picker>
            </v-menu>
          </div>
        </template>
      </v-radio-group>

      <div class="date-range__actions">
        <v-btn class="btn-close" @click="handleClose" flat>{{ $t('close') }}</v-btn>
        <v-btn :disabled="isInvalidCustomTime" @click="handleApply" depressed color="accent">{{
          $t('apply')
        }}</v-btn>
      </div>
    </v-list>
    <div class="date-range-tooltip" v-else>
      <div class="a-time-picker__chip__wrap">
        <v-chip
          class="a-time-picker__chip"
          v-for="(time, index) in timeOptions"
          :key="index"
          @click="handleSelectTimeChip(time.value)"
          :class="timeRange && timeRange.option === time.value ? 'active' : ''"
          >{{ time.text }}</v-chip
        >
      </div>
      <v-dialog
        content-class="a-time-picker__custom-time-dialog"
        persistent
        v-model="openCustomTime"
        transition="slide-y-reverse-transition"
      >
        <v-card color="#F2F4F8">
          <v-layout row align-center class="a-time-picker__custom-time-dialog__header">
            <v-btn icon @click="openCustomTime = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
            <v-toolbar-title class="flex grow ml-0 text-xs-center" style="padding-right: 36px">
              {{ $t('date_range_picker.time_range_title') }}
            </v-toolbar-title>
          </v-layout>
          <div class="body-2 mx-3 my-2" style="color: #7a8189">
            {{
              $t('date_range_picker.time_range_desc', {
                numDays: this.maxDaysRange
              })
            }}
          </div>
          <v-menu v-model="showFromDate" :full-width="true" :nudge-right="220" :nudge-top="50">
            <ATextField
              dark
              svgIcon
              readonly
              slot="activator"
              name="fromDate"
              appendIcon="DateTime"
              :label="$t('date_range_picker.from_time')"
              v-model="formatedFromDate"
            />
            <v-date-picker
              header-color="warning"
              v-model="params.fromDate"
              :max="maxDate"
              @input="updateFromDate"
            ></v-date-picker>
          </v-menu>
          <div class="a-time-picker__custom-time-dialog__divider pl-3 pr-3">
            <v-divider />
          </div>
          <v-menu v-model="showToDate" :full-width="true" :nudge-right="220" :nudge-top="20">
            <ATextField
              dark
              svgIcon
              readonly
              name="toDate"
              slot="activator"
              appendIcon="DateTime"
              :label="$t('date_range_picker.to_time')"
              v-model="formatedToDate"
            />
            <v-date-picker
              header-color="warning"
              v-model="params.toDate"
              :max="maxDate"
              :min="minToDate"
              @input="updateToDate"
            ></v-date-picker>
          </v-menu>
          <div class="a-time-picker__custom-time-dialog__divider pl-3 pr-3">
            <v-divider />
          </div>
          <div class="a-time-picker__custom-time-dialog__btn px-3 pt-3 pb-3">
            <v-btn block :disabled="isInvalidCustomTime" depressed @click="handleApplyCustomTime">{{
              $t('apply')
            }}</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ATextField from '../../components/ahamove/ATextField'

const { remove } = require('@/plugins/lodash')

const TIME = {
  ALL: 'ALL',
  TODAY: 'TODAY',
  THIS_WEEK: 'THIS_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  CUSTOM: 'CUSTOM'
}

const ADVANCED_TIME = {
  LAST_3_DAYS: 'LAST_3_DAYS',
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS'
}

const dateFormat = 'DD/MM/YYYY'

export default {
  name: 'ATimePicker',
  props: {
    initOption: {
      type: String,
      default: TIME.ALL
    },
    initFromDate: {
      type: Number
    },
    initToDate: {
      type: Number
    },
    allowAllOption: {
      type: Boolean
    },
    allowCustomOption: {
      type: Boolean
    },
    allowAdvancedOptions: {
      type: Boolean
    },
    onChange: {
      type: Function
    },
    onClose: {
      type: Function
    },
    maxDaysRange: {
      type: Number,
      default: 31
    }
  },
  components: {
    ATextField
  },
  data() {
    return {
      radioGroup: this.initOption,
      requestQueue: null,
      timeRange: null,
      loading: false,
      timeOptions: [],
      orders: [],
      templateOptions: {
        TODAY: {
          key: 'TODAY',
          label: this.$t(`date_range_picker.today`),
          hint: this.$moment().format(dateFormat)
        },
        THIS_WEEK: {
          key: 'THIS_WEEK',
          label: this.$t(`date_range_picker.this_week`),
          hint: `${this.$moment().startOf('week').format(dateFormat)} - ${this.$moment()
            .endOf('week')
            .format(dateFormat)}`
        },
        THIS_MONTH: {
          key: 'THIS_MONTH',
          label: this.$t(`date_range_picker.this_month`),
          hint: `${this.$moment().startOf('month').format(dateFormat)} - ${this.$moment()
            .endOf('month')
            .format(dateFormat)}`
        },
        LAST_3_DAYS: {
          key: 'LAST_3_DAYS',
          label: this.$t(`date_range_picker.last_3_days`),
          hint: `${this.$moment().add(-3, 'days').format(dateFormat)} - ${this.$moment().format(
            dateFormat
          )}`
        },
        LAST_7_DAYS: {
          key: 'LAST_7_DAYS',
          label: this.$t(`date_range_picker.last_7_days`),
          hint: `${this.$moment().add(-7, 'days').format(dateFormat)} - ${this.$moment().format(
            dateFormat
          )}`
        },
        LAST_30_DAYS: {
          key: 'LAST_30_DAYS',
          label: this.$t(`date_range_picker.last_30_days`),
          hint: `${this.$moment().add(-30, 'days').format(dateFormat)} - ${this.$moment().format(
            dateFormat
          )}`
        }
      },
      params: {
        fromDate: null,
        toDate: null,
        time: null
      },
      showFromDate: false,
      showToDate: false,
      maxDate: this.$moment().format('YYYY-MM-DD'),
      openCustomTime: null
    }
  },
  computed: {
    customTime() {
      return this.params.time === TIME.CUSTOM
    },
    isInvalidCustomTime() {
      return (
        this.customTime && (!this.timeRange || !this.timeRange.from_time || !this.timeRange.to_time)
      )
    },
    formatedFromDate() {
      if (this.params.fromDate) {
        return this.$moment(this.params.fromDate).format('DD/MM/YYYY')
      }
      return this.params.fromDate
    },
    formatedToDate() {
      if (this.params.toDate) {
        return this.$moment(this.params.toDate).format('DD/MM/YYYY')
      }
      return this.params.toDate
    },
    minToDate() {
      return this.params.fromDate
    }
  },
  methods: {
    updateFromDate() {
      this.handleSelectTime(TIME.CUSTOM)
    },
    updateToDate() {
      this.handleSelectTime(TIME.CUSTOM)
    },
    handleSelectTime(value) {
      this.params.time = value
      let range = this.getDateFilter()
      if (range) {
        this.timeRange = range
      }
    },
    handleSelectTimeChip(value) {
      if (value === TIME.CUSTOM) {
        this.openCustomTime = true
      } else {
        this.params.time = value
        let range = this.getDateFilter()
        if (range) {
          this.timeRange = range
        }
        this.$emit('onChange', this.timeRange)
      }
    },
    getDateFilter() {
      let fromDate, toDate
      switch (this.params.time) {
        case TIME.ALL:
          break
        case TIME.TODAY:
          fromDate = this.$moment().startOf('day').unix()
          toDate = this.$moment().endOf('day').unix()
          break
        case TIME.THIS_WEEK:
          fromDate = this.$moment().startOf('week').unix()
          toDate = this.$moment().endOf('week').unix()
          break
        case TIME.THIS_MONTH:
          fromDate = this.$moment().startOf('month').unix()
          toDate = this.$moment().endOf('month').unix()
          break
        case ADVANCED_TIME.LAST_3_DAYS:
          fromDate = this.$moment().add(-3, 'days').unix()
          toDate = this.$moment().endOf('day').unix()
          break
        case ADVANCED_TIME.LAST_7_DAYS:
          fromDate = this.$moment().add(-7, 'days').unix()
          toDate = this.$moment().endOf('day').unix()
          break
        case ADVANCED_TIME.LAST_30_DAYS:
          fromDate = this.$moment().add(-30, 'days').unix()
          toDate = this.$moment().endOf('day').unix()
          break
        case TIME.CUSTOM:
          fromDate = this.$moment(this.params.fromDate + ' 00:00').unix()
          toDate = this.$moment(this.params.toDate + ' 23:59').unix()
          if (toDate && fromDate) {
            const diffDays = this.$moment(this.params.toDate).diff(
              this.$moment(this.params.fromDate),
              'days'
            )
            if (diffDays > this.maxDaysRange) {
              this.$store.dispatch('setSnackbar', {
                visible: true,
                title: this.$t('date_range_picker.invalid_date_range', {
                  numDays: this.maxDaysRange
                }),
                color: 'error',
                timeout: 3000
              })
              return null
            }
          }
          break
        default:
          break
      }
      if (fromDate && toDate) {
        return {
          from_time: fromDate,
          to_time: toDate,
          option: this.params.time
        }
      }

      return { option: this.params.time }
    },
    handleClose() {
      this.$emit('onClose')
    },
    handleApply() {
      this.$emit('onChange', this.timeRange)
    },
    handleApplyCustomTime() {
      this.params.time = TIME.CUSTOM
      let range = this.getDateFilter()
      if (range) {
        this.timeRange = range
      }
      this.$emit('onChange', this.timeRange)
      this.openCustomTime = false
    }
  },

  beforeMount() {
    Object.keys(TIME).forEach((key) => {
      this.timeOptions.push({
        value: TIME[key],
        text: this.$t('time.' + TIME[key])
      })
    })

    if (this.allowAdvancedOptions) {
      Object.keys(ADVANCED_TIME).forEach((key) => {
        this.timeOptions.push({
          value: ADVANCED_TIME[key],
          text: this.$t('time.' + ADVANCED_TIME[key])
        })
      })
    }

    if (!this.allowAllOption) {
      remove(this.timeOptions, (item) => {
        return item.value === TIME.ALL
      })
    }

    if (!this.allowCustomOption) {
      remove(this.timeOptions, (item) => {
        return item.value === TIME.CUSTOM
      })
    }

    this.params.time = this.initOption
    if (this.params.time && this.params.time === TIME.CUSTOM) {
      this.params.fromDate = this.$moment(this.initFromDate * 1000)
        .toISOString()
        .substr(0, 10)
      this.params.toDate = this.$moment(this.initToDate * 1000)
        .toISOString()
        .substr(0, 10)
    }
  },

  mounted() {
    this.timeRange = this.getDateFilter()
    if (this.isMobile) {
      this.timeOptions = this.timeOptions.filter((item) => item.value !== 'TODAY')
    }
  }
}
</script>

<i18n src="@/locales2/share/datetime.json"></i18n>

<style lang="scss" scoped>
.v-list--two-line .v-list__tile {
  height: 60px;
}

.v-menu__content {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}

.export-csv-btn {
  margin: 0;
  padding: 0 12px;
  text-transform: none;
  border-radius: 8px;
  height: 46px;

  &::before {
    background-color: #f2f2f2 !important;
  }

  .info-icon {
    margin-right: 6px;
  }
}

.date-range-tooltip {
  background: white;

  .v-subheader {
    padding-top: 20px;
  }

  .date-range__header {
    color: #1a1a1a;
    font-weight: 500;
    font-size: 16px;
  }

  .subnote {
    margin: 5px 18px;
    color: #7a8189;
  }

  .v-input--selection-controls {
    margin-top: 0;

    .v-input__control {
      .v-list__tile__action {
        min-width: 40px;
      }
    }
  }

  .box-select {
    margin: 0 20px 0 20px;

    .v-input__slot {
      border-radius: 4px;
      background: #f2f2f2;

      .v-select {
        .v-select__selections {
          color: rgba(0, 0, 0, 0.54);
        }
      }
    }
  }

  .date-range__actions {
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;

    .btn-close {
      background: white;
      margin-right: 10px;
    }

    button {
      width: 95px;
      height: 40px;
      margin: 10px 0;
      text-transform: none;
    }
  }
}

.a-time-picker__chip__wrap {
  padding: 8px 0;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.a-time-picker__chip {
  width: 114px;
  height: 44px;
  background-color: rgba(255, 130, 0, 0.17);
  border-radius: 4px;
  color: #ff8200;
  font-size: 14px;
  justify-content: center;

  &.active {
    background-color: #ff8200;
    font-weight: bold;
    color: white;
  }

  .v-chip__content {
    padding: 19px 12px;
  }

  &:focus:not(.v-chip--disabled) {
    box-shadow: none !important;
  }
}
</style>

<style lang="scss">
.box-select {
  .v-input__control {
    width: 100%;
    min-height: 56px;

    .v-input__slot {
      .v-select__selections {
        color: rgba(0, 0, 0, 0.54);
      }
    }

    .v-text-field__slot {
      label {
        line-height: 32px;
      }
    }
  }
}

.box-select.v-text-field--solo {
  .v-input__slot {
    border-radius: 4px;
  }
}

.date-range-tooltip {
  .v-input--selection-controls {
    .v-input__control {
      width: 100% !important;
    }
  }

  .a-time-picker__option {
    align-items: flex-start;

    label {
      .a-time-picker__label {
        color: #1a1a1a;

        .a-time-picker__label-sub {
          color: #7a8189;
          font-size: 13px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .transactions-statistics-mobile-dialog {
    .v-sheet {
      border-radius: 0 !important;
    }
  }

  .a-time-picker__custom-time-dialog {
    margin: 0;
    margin-top: auto;

    .v-card {
      border-radius: 8px 8px 0 0 !important;
    }

    .a-time-picker__custom-time-dialog__divider {
      background-color: white;

      .v-divider {
        width: 100%;
      }
    }

    &__header {
      background-color: white;
      border-bottom: 1px solid #f2f4f8;
    }

    .v-menu {
      .v-input__control {
        background-color: white;
        height: 56px;

        .v-input__slot {
          background-color: white;
          margin-bottom: 0;
          padding: 0 16px;
          height: 100%;

          .v-text-field__slot {
            input {
              font-weight: bold;
            }
          }
        }
      }
    }

    &__btn {
      background-color: white;

      .v-btn {
        background-color: #fe5f00 !important;
        color: white;
        height: 56px;
        text-transform: initial;
        border-radius: 4px;
        font-weight: bold;
      }
    }
  }
}
</style>
